module.exports = __webpack_public_path__ + "img/P150T_weapon_116.65a4f7a3.png";